import * as api from '../../apis/additionalFields';
import { apiCall } from '~/lib/redux/api';
import { EntityActions } from '~/apps/shared/actions/consts';
import { AdditionalFieldActions } from './consts';
import { AdditionalFieldNormalizer } from './normalize';


export function getAdditionalFieldListByLocationId(locationId: string) {
  return apiCall({
    actions: [
      AdditionalFieldActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, AdditionalFieldActions.LOAD_LIST_SUCCESS],
      AdditionalFieldActions.LOAD_ERROR,
    ],
    normalizer: [AdditionalFieldNormalizer],
    fn: () => api.getFieldsByLocationId(locationId),
  })
}

export function getAdditionalFieldByOrgId(OrgId: string) {
  return apiCall({
    actions: [
      AdditionalFieldActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, AdditionalFieldActions.LOAD_LIST_SUCCESS],
      AdditionalFieldActions.LOAD_ERROR,
    ],
    normalizer: [AdditionalFieldNormalizer],
    fn: () => api.getFieldsByOrgId(OrgId),
  })
}

export function getFieldsArrayByLocationId(locationId: string) {
  return apiCall({
    actions: [
      AdditionalFieldActions.LOAD_REQUEST,
      AdditionalFieldActions.LOAD_SUCCESS,
      AdditionalFieldActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.getFieldsByLocationId(locationId),
  })
}

export function getFieldsArrayOrgId(OrgId: string) {
  return apiCall({
    actions: [
      AdditionalFieldActions.LOAD_REQUEST,
      AdditionalFieldActions.LOAD_SUCCESS,
      AdditionalFieldActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.getFieldsByOrgId(OrgId),
  })
}

export function addAdditionalField(req) {
  return apiCall({
    actions: [
      AdditionalFieldActions.LOAD_REQUEST,
      [AdditionalFieldActions.LOAD_SUCCESS],
      AdditionalFieldActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.addAdditionalField(req),
  })
}

export function updateAdditionalField(fieldId: string, req) {
  return apiCall({
    actions: [
      AdditionalFieldActions.LOAD_REQUEST,
      [AdditionalFieldActions.LOAD_SUCCESS],
      AdditionalFieldActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.updateAdditionalField(fieldId, req),
  })
}

export function deleteAdditionalField(fieldId: string) {
  return apiCall({
    actions: [
      AdditionalFieldActions.LOAD_REQUEST,
      [AdditionalFieldActions.LOAD_SUCCESS],
      AdditionalFieldActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.deleteAdditionalField(fieldId),
  })
}


export function setAdditionalFieldCurrentPage(page: number = 0) {
  return {
    type: AdditionalFieldActions.SET_CURRENT_PAGE,
    currentPage: page,
  }
}
